import { PageRenderer } from "./PageRender";
import * as paths from "./paths";
import OrderPage from "pages/Order";
import DashboardPage from "pages/Dashboard";
import AdminFeePage from "pages/Admin-fee";
import InvoicePage from "pages/Invoice";
import InvoiceFormPage from "pages/Invoice/InvoiceForm";
import ConfigurationPage from "pages/Configuration/List";
import AddNewSite from "pages/Configuration/Create";
import EditConfig from "pages/Configuration/Edit";
import ImportExportProducts from "pages/import-export-products";
import InquiryPage from "pages/Inquiry/List";
import EditInquiryPage from "pages/Inquiry/Edit";
import SalesLeadsPage from "pages/sales-leads/List";
import AddSalesLeadPage from "pages/sales-leads/Create";
import EditSalesLeadPage from "pages/sales-leads/Edit";
import UserRolePage from "pages/permissions";
import SalesUserPage from "pages/sales-user/List";
import CreateSalesUserPage from "pages/sales-user/Create";
import EditSalesUserPage from "pages/sales-user/Edit";
import StaffUserPage from "pages/staff-user/List";
import CreateStaffUserPage from "pages/staff-user/Create";
import EditStaffUserPage from "pages/staff-user/Edit";
import RequestSalesLeadPage from "pages/sales-leads/RequestForm";
import { PermissionKeys } from "Constant/Constant";

export const Routes = {
  Dashboard: "Dashboard",
  Order: "order",
  Login: "Login",
  AdminFee: "AdminFee",
  Invoice: "Invoice",
  InvoiceForm: "InvoiceForm",
  Configuration: "Configuration",
  AddNewSite: "AddNewSite",
  EditConfig: "EditConfig",
  Products: "Products",
  Inquiry: "Inquiry",
  EditInquiry: "EditInquiry",
  SalesLeads: "SalesLeads",
  AddSalesLeads: "AddSalesLeads",
  EditSalesLeads: "EditSalesLeads",
  UserRole: "UserRole",
  SalesUser: "SalesUser",
  CreateSalesUser: "CreateSalesUser",
  EditSalesUser: "EditSalesUser",
  StaffUser: "StaffUser",
  CreateStaffUser: "CreateStaffUser",
  EditStaffUser: "EditStaffUser",
  RequestSalesLead: "RequestSalesLead",
  EditRequestSalesLead: "EditRequestSalesLead",
};

// routes.js
export const routes = [
  {
    name: Routes.Dashboard,
    path: paths.DASHBOARD_PATH,
    requiredPermission: PermissionKeys.VIEW_DASHBOARD,
    element: <PageRenderer element={<DashboardPage />} />,
  },
  {
    name: Routes.AdminFee,
    path: paths.ADMIN_FEE_PATH,
    requiredPermission: PermissionKeys.VIEW_ADMIN_FEE,
    element: <PageRenderer element={<AdminFeePage />} />,
  },
  {
    name: Routes.Invoice,
    path: paths.INVOICE_PATH,
    requiredPermission: PermissionKeys.VIEW_INVOICES,
    element: <PageRenderer element={<InvoicePage />} />,
  },
  {
    name: Routes.InvoiceForm,
    path: paths.INVOICE_FORM_PATH,
    requiredPermission: PermissionKeys.GENERATE_INVOICE,
    element: <PageRenderer element={<InvoiceFormPage />} />,
  },
  {
    name: Routes.Configuration,
    path: paths.CONFIGURATION_PATH,
    requiredPermission: PermissionKeys.MANAGE_CONFIGURATIONS,
    element: <PageRenderer element={<ConfigurationPage />} />,
  },
  {
    name: Routes.AddNewSite,
    path: paths.ADD_NEW_SITE_PATH,
    requiredPermission: PermissionKeys.MANAGE_CONFIGURATIONS,
    element: <PageRenderer element={<AddNewSite />} />,
  },
  {
    name: Routes.EditConfig,
    path: paths.EDIT_CONFIG_PATH,
    requiredPermission: PermissionKeys.MANAGE_CONFIGURATIONS,
    element: <PageRenderer element={<EditConfig />} />,
  },
  {
    name: Routes.Products,
    path: paths.PRODUCTS_IMPORT_EXPORT_PATH,
    requiredPermission: PermissionKeys.IMPORT_PRODUCTS,
    element: <PageRenderer element={<ImportExportProducts />} />,
  },
  {
    name: Routes.Inquiry,
    path: paths.INQUIRY_PATH,
    requiredPermission: PermissionKeys.VIEW_INQUIRIES,
    element: <PageRenderer element={<InquiryPage />} />,
  },
  {
    name: Routes.EditInquiry,
    path: paths.EDIT_INQUIRY_PATH,
    requiredPermission: PermissionKeys.EDIT_INQUIRIES,
    element: <PageRenderer element={<EditInquiryPage />} />,
  },
  {
    name: Routes.SalesLeads,
    path: paths.SALES_LEADS_PATH,
    requiredPermission: PermissionKeys.VIEW_ALL_LEADS,
    element: <PageRenderer element={<SalesLeadsPage />} />,
  },
  {
    name: Routes.AddSalesLeads,
    path: paths.ADD_SALES_LEADS_PATH,
    requiredPermission: PermissionKeys.CREATE_LEAD,
    element: <PageRenderer element={<AddSalesLeadPage />} />,
  },
  {
    name: Routes.EditSalesLeads,
    path: paths.EDIT_SALES_LEADS_PATH,
    requiredPermission: PermissionKeys.EDIT_ANY_LEAD,
    element: <PageRenderer element={<EditSalesLeadPage />} />,
  },
  {
    name: Routes.UserRole,
    path: paths.USER_ROLE_PATH,
    requiredPermission: PermissionKeys.MANAGE_PERMISSIONS,
    element: <PageRenderer element={<UserRolePage />} />,
  },
  {
    name: Routes.SalesUser,
    path: paths.SALES_USER_PATH,
    requiredPermission: PermissionKeys.MANAGE_SALES_USERS,
    element: <PageRenderer element={<SalesUserPage />} />,
  },
  {
    name: Routes.CreateSalesUser,
    path: paths.CREATE_SALES_USER_PATH,
    requiredPermission: PermissionKeys.MANAGE_SALES_USERS,
    element: <PageRenderer element={<CreateSalesUserPage />} />,
  },
  {
    name: Routes.EditSalesUser,
    path: paths.EDIT_SALES_USER_PATH,
    requiredPermission: PermissionKeys.MANAGE_SALES_USERS,
    element: <PageRenderer element={<EditSalesUserPage />} />,
  },
  {
    name: Routes.StaffUser,
    path: paths.STAFF_USER_PATH,
    requiredPermission: PermissionKeys.MANAGE_STAFF_USERS,
    element: <PageRenderer element={<StaffUserPage />} />,
  },
  {
    name: Routes.CreateStaffUser,
    path: paths.CREATE_STAFF_USER_PATH,
    requiredPermission: PermissionKeys.MANAGE_STAFF_USERS,
    element: <PageRenderer element={<CreateStaffUserPage />} />,
  },
  {
    name: Routes.EditStaffUser,
    path: paths.EDIT_STAFF_USER_PATH,
    requiredPermission: PermissionKeys.MANAGE_STAFF_USERS,
    element: <PageRenderer element={<EditStaffUserPage />} />,
  },
  {
    name: Routes.RequestSalesLead,
    path: paths.REQUEST_SALES_LEAD_PATH,
    requiredPermission: [PermissionKeys.REQUEST_DEMO, PermissionKeys.REQUEST_LIVE],
    element: <PageRenderer element={<RequestSalesLeadPage />} />,
  },
  {
    name: Routes.EditRequestSalesLead,
    path: paths.EDIT_REQUEST_SALES_LEAD_PATH,
    requiredPermission: [PermissionKeys.REQUEST_DEMO, PermissionKeys.REQUEST_LIVE],
    element: <PageRenderer element={<RequestSalesLeadPage />} />,
  },
  {
    name: Routes.Order,
    path: paths.ORDERS_PATH,
    requiredPermission: PermissionKeys.VIEW_ORDERS,
    element: <PageRenderer element={<OrderPage />} />,
  },
];
